var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/graphic-text.css';
let GraphicText = class GraphicText extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'is-stacked-left';
        this.href = undefined;
        this.target = '_self';
        this.icon = '';
        this.icon_color = '';
        this.image = '';
    }
    static get styles() {
        if (env.debug) {
            return css `
        `;
        }
        return [style];
    }
    firstUpdated() {
        let gs1TextContainer = this.shadowRoot?.querySelector('figcaption');
        const childArray = Array.from(this.children);
        childArray.forEach((item) => {
            if (!item.hasAttribute('slot')) {
                gs1TextContainer.appendChild(item);
            }
        });
    }
    clickRedirect() {
        if (this.href) {
            window.open(this.href, this.target);
        }
    }
    render() {
        var icon_family = '';
        var icon_type = '';
        var cursor_style = '';
        if (this.icon.includes('fab')) {
            icon_family = 'fab';
        }
        else if (this.icon.includes('fas')) {
            icon_family = 'fas';
        }
        icon_type = this.icon.replace(icon_family + ' ', '');
        if (this.href) {
            cursor_style = 'pointer';
        }
        return html `
    ${env.debug ? html `<link rel="stylesheet" href="/css/graphic-text.css" />` : html ``}

    <figure class="text-with-graphic ${this.type}" @click="${this.clickRedirect}" style="cursor: ${cursor_style}">
      ${this.image != "" ? html `<img src="${this.image}" alt="image">` : html ``}
      ${this.icon != "" ? html `<gs1-fa-icon family="${icon_family}" type="${icon_type}" style="color: ${this.icon_color}"></gs1-fa-icon>` : html ``}
      <figcaption>
      </figcaption>
    </figure>`;
    }
};
__decorate([
    property()
], GraphicText.prototype, "type", void 0);
__decorate([
    property()
], GraphicText.prototype, "href", void 0);
__decorate([
    property()
], GraphicText.prototype, "target", void 0);
__decorate([
    property()
], GraphicText.prototype, "icon", void 0);
__decorate([
    property()
], GraphicText.prototype, "icon_color", void 0);
__decorate([
    property()
], GraphicText.prototype, "image", void 0);
GraphicText = __decorate([
    customElement('gs1-graphic-text')
], GraphicText);
export { GraphicText };
//# sourceMappingURL=graphic-text.js.map